/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins/plugins'

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from './firebase'
import { useAuthStore } from './store/authstore'

const app = createApp(App)

registerPlugins(app)

let appMounted = false

onAuthStateChanged(auth, async (user) => {
    const authStore = useAuthStore()

    if (user) {
        await authStore.restoreUser()
    } else {
        authStore.user = null
    }

    if (!appMounted) {
        app.mount('#app')
        appMounted = true
    }
})
